"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));
var _envConstants = require("../constants/envConstants");
var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));
var _ShipmentPlanViewerBody = _interopRequireDefault(require("./ShipmentPlanViewerBody"));
var _react2 = require("@emotion/react");
/* eslint-disable react/forbid-prop-types,consistent-return */

var ShipmentPlanViewer = function ShipmentPlanViewer(props) {
  return (0, _react2.jsx)(_ErrorBoundary["default"], null, (0, _react2.jsx)(_ShipmentPlanViewerBody["default"], props));
};
ShipmentPlanViewer.propTypes = {
  className: _propTypes["default"].string,
  style: _reactStyleProptype["default"],
  accessToken: _propTypes["default"].string.isRequired,
  shipmentPlanUrl: _propTypes["default"].string.isRequired,
  env: _propTypes["default"].oneOf([_envConstants.PRD, _envConstants.INT]),
  showBasicInfo: _propTypes["default"].bool,
  showCondensedView: _propTypes["default"].bool
};
ShipmentPlanViewer.defaultProps = {
  className: undefined,
  style: undefined,
  env: _envConstants.PRD,
  showBasicInfo: true,
  showCondensedView: false
};
var _default = exports["default"] = ShipmentPlanViewer;